import React, { useEffect, useState } from "react";
import Sidebar from "../../components/Sidebar";
import Navbar from "../../components/Navbar";
import Title from "../../components/Title";
import Button from "../../components/Button";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  TablePagination,
  useStepContext,
} from "@mui/material";
import { Edit as EditIcon, Delete as DeleteIcon } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import AdminSidebar from "../../components/AdminSidebar";
import { Link, useNavigate } from "react-router-dom";
import { getClickedUserData } from "../../store/reducerSlices/adminClickedSlice";
import dataService from "../../services/data-service";
import { toast } from "react-toastify";

import { getAdminData } from "../../store/reducerSlices/adminSlice";
import { updateAdminData } from "../../store/reducerSlices/adminSlice";

const initialData = [
  {
    adminId: "6DF6740C-D8E9-4A55-8769-0E58AE6322F6",
    name: "Achyut Gaihre",
    email: "achyut@techglazers.com",
    imageUrl: "achyut.png",
    userName: "64aa44a3-c0e5-4616-97b6-4c023b7aa272",
    phoneNumber: "1234567890",
    deleted: false,
  },
];

const Index = () => {
  const showStudent = false;
  const [searchQuery, setSearchQuery] = useState("");

  const usersField = ["All"];
  const [isRetrivingData, setIsRetrivingData] = useState(false);
  const [isDeleting, setisDeleting] = useState(false);

  const [activeField, setActiveField] = useState("All");
  // const [data, setData] = useState(initialData);
  const [data, setData] = useState("");

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [selectedUser, setSelectedUser] = useState("");
  const [selectedUserID, setSelectedUserID] = useState("");

  const navigate = useNavigate();
  const dispatch = useDispatch();

  // A partner center admin gets the same page, but the backend returns only the admins of
  // their own center - so it is presented as their team rather than the whole admin roster.
  const admin = useSelector((state) => state.admin.admin);
  const isPartnerCenter = admin?.role === "PartnerCenter";
  const pageTitle = isPartnerCenter ? "Center Team" : "Admin";
  const addButtonTitle = isPartnerCenter ? "Add Team Member" : "Add New Admin";

  const handleSelectStudent = (rowid, candidateID) => {
    navigate("/dashboard", { state: { userId: candidateID } });
  };

  // const handleEdit = (id) => {
  //     // Handle edit functionality here
  // };

  const { isSidebarCollapsed, openMobileSideBar } = useSelector(
    (state) => state.hamburger
  );

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0); // Reset to the first page when rows per page changes
  };
  const handleSelectedAdminDelete = (name, candidateID) => {
    setSelectedUser(name);
    setSelectedUserID(candidateID);
    setShowConfirmDialog(true);
  };
  const self = useSelector((state) => state.admin.admin);
  const handleDelete = async (adminId) => {
    // Handle delete functionality here
    setisDeleting(true);
    try {
      setData(data.filter((row) => row.adminId !== adminId));
      await dataService.patchData(`/AdminAccount/delete?adminId=${adminId}`);
      toast.success("Admin Deleted sucessfully");
    } catch (error) {
      //   console.log("error deleteing admin", error);
      toast.error("Failed to Delete Admin");
    } finally {
      window.location.reload();
      setisDeleting(false);
    }
  };

  const handleConfirmChange = (candidateID) => {
    // the second attribute is used to pass data into dashboard when it navigates to dashboard. we can access using const location = useLocation();
    // const { userId } = location.state || {}; in dashboard
    navigate("/dashboard", { state: { userId: candidateID } });
  };

  const handleCancelChange = () => {
    setShowConfirmDialog(false);
  };

  const filteredData =
    data &&
    data.filter(
      (
        row // Filter data based on the search query
      ) =>
        row.name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
        row.email?.toLowerCase().includes(searchQuery.toLowerCase()) ||
        row.phoneNumber?.toLowerCase().includes(searchQuery.toLowerCase()) ||
        row.address?.toLowerCase().includes(searchQuery.toLowerCase()) ||
        row.partnerTrainingCenter
          ?.toLowerCase()
          .includes(searchQuery.toLowerCase())
    );
  const paginatedData = filteredData.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  const fetchAllAdmin = async () => {
    setIsRetrivingData(true);
    try {
      const response = await dataService.getData(
        `/AdminInformation/getall/admin`
      );
      const onlyNotDeletedData = response.filter(
        (row) => row.deleted === false
      );
      setData(onlyNotDeletedData);
      setIsRetrivingData(false);
    } catch (error) {
      console.log("error", error);
      toast.error("Error fetching data");
      setIsRetrivingData(false);
    }
  };

  useEffect(() => {
    fetchAllAdmin();
  }, []);

  return (
    <div>
      <div
        className={`block ${openMobileSideBar ? "" : "flex"}  ${
          showConfirmDialog ? "blurred" : ""
        }`}
      >
        <div
          className={`hidden md:block ${
            isSidebarCollapsed ? "w-20" : "md:w-[250px] lg:w-[300px]"
          }`}
        >
          <AdminSidebar />
        </div>
        <div
          className={` ${
            openMobileSideBar ? "block fixed top-0 z-20" : "hidden"
          } w-lvw block md:hidden`}
        >
          <AdminSidebar />
        </div>
        <div
          className={`w-full border-red-700 ${
            isSidebarCollapsed ? "w-[100%-80px]" : "w-5/6"
          } ${openMobileSideBar ? "w-full top-0" : "w-full"}`}
        >
          <Navbar showStudent={showStudent} />
          <div className="m-4 md:m-8">
            <div className="md:flex justify-between">
              <Title title={pageTitle} />
            </div>
            <div className="flex justify-between mt-4">
              <div className="flex justify-between w-full">
                <div className="flex items-end">
                  {usersField.map((item, index) => (
                    <span
                      key={index}
                      className={`font-poppins text-gray-500 cursor-pointer px-8 pb-4 text-xs md:text-[14px] ${
                        activeField === item
                          ? "border-b-[3px] border-primary-title"
                          : ""
                      }`}
                      onClick={() => setActiveField(item)}
                    >
                      {item}
                    </span>
                  ))}
                </div>
                <div className="flex ">
                  <Link to="register">
                    <Button
                      title={addButtonTitle}
                      className=" mb-1 text-[14px] p-3"
                    />
                  </Link>
                </div>
              </div>
            </div>
            <hr className="border border-slate-300 -mx-8" />
            <div className="flex space-x-4 mt-4">
              <input
                type="text"
                className="rounded-md border-2 w-full p-2 outline-none font-poppins text-[14px]"
                placeholder="Search"
                value={searchQuery} // Bind input value to searchQuery state
                onChange={(e) => setSearchQuery(e.target.value)} // Update searchQuery state on input change
              />
            </div>
            {isRetrivingData ? (
              <div className="flex justify-center items-center w-full mt-32">
                <svg
                  aria-hidden="true"
                  role="status"
                  className="inline h-12 w-12 md:w-28 md:h-28 me-3 text-primary-title animate-spin "
                  viewBox="0 0 100 101"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                    fill="#E5E7EB"
                  />
                  <path
                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                    fill="currentColor"
                  />
                </svg>
              </div>
            ) : (
              <div className="mt-6 shadow-md text-xs md:text-base">
                <TableContainer component={Paper}>
                  <Table>
                    <TableHead
                      style={{
                        backgroundColor: "#2b5972",
                        fontFamily: "Poppins , sans-serif",
                      }}
                    >
                      <TableRow style={{ backgroundColor: "#2b5972" }}>
                        <TableCell
                          style={{
                            color: "#fff",
                            fontFamily: "Poppins , sans-serif",
                          }}
                        >
                          {" "}
                          ID
                        </TableCell>
                        <TableCell
                          style={{
                            color: "#fff",
                            fontFamily: "Poppins , sans-serif",
                          }}
                        >
                          Name
                        </TableCell>
                        <TableCell
                          style={{
                            color: "#fff",
                            fontFamily: "Poppins , sans-serif",
                          }}
                        >
                          Address
                        </TableCell>
                        <TableCell
                          style={{
                            color: "#fff",
                            fontFamily: "Poppins , sans-serif",
                          }}
                        >
                          Email
                        </TableCell>
                        <TableCell
                          style={{
                            color: "#fff",
                            fontFamily: "Poppins , sans-serif",
                          }}
                        >
                          Phone
                        </TableCell>
                        <TableCell
                          style={{
                            color: "#fff",
                            fontFamily: "Poppins , sans-serif",
                          }}
                        >
                          Partner Training Center
                        </TableCell>
                        {/* <TableCell style={{ color: '#fff' }}>Program</TableCell> */}
                        <TableCell style={{ color: "#fff" }}>Action</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {paginatedData &&
                        paginatedData.map((row, index) => (
                          <TableRow key={row.adminId}>
                            <TableCell
                              style={{ fontFamily: "Poppins , sans-serif" }}
                            >
                              {index + 1}
                            </TableCell>
                            <TableCell
                              style={{ fontFamily: "Poppins , sans-serif" }}
                            >
                              {row.name}
                            </TableCell>
                            <TableCell
                              style={{ fontFamily: "Poppins , sans-serif" }}
                            >
                              {row.address}
                            </TableCell>
                            <TableCell
                              style={{ fontFamily: "Poppins , sans-serif" }}
                            >
                              {row.email}
                            </TableCell>
                            <TableCell
                              style={{ fontFamily: "Poppins , sans-serif" }}
                            >
                              {row.phoneNumber}
                            </TableCell>
                            <TableCell
                              style={{ fontFamily: "Poppins , sans-serif" }}
                            >
                              {/* "None" is how an administrator is stored, so show it as such */}
                              {!row.partnerTrainingCenter ||
                              row.partnerTrainingCenter === "None"
                                ? "-"
                                : row.partnerTrainingCenter}
                            </TableCell>
                            {/* <TableCell onClick={() => handleSelectedUserChange(row.name, row.candidateID)}>{row.program}</TableCell> */}

                            {/* <TableCell onClick={() => handleSelectStudent(row.id, row.candidateID)}>{row.candidateID}</TableCell>
                                                <TableCell onClick={() => handleSelectStudent(row.id, row.candidateID)}>{row.name}</TableCell>
                                                <TableCell onClick={() => handleSelectStudent(row.id, row.candidateID)}>{row.address}</TableCell>
                                                <TableCell onClick={() => handleSelectStudent(row.id, row.candidateID)}>{row.email}</TableCell>
                                                <TableCell onClick={() => handleSelectStudent(row.id, row.candidateID)}>{row.phone}</TableCell>
                                                <TableCell onClick={() => handleSelectStudent(row.id, row.candidateID)}>{row.program}</TableCell> */}
                            <TableCell>
                              {/* <IconButton onClick={() => handleEdit(row.id)}>
                                                    <EditIcon />
                                                </IconButton> */}

                              {self.adminId !== row.adminId && (
                                <IconButton
                                  onClick={() =>
                                    handleSelectedAdminDelete(
                                      row.name,
                                      row.adminId
                                    )
                                  }
                                  style={{ color: "#9A3C3C" }}
                                >
                                  <DeleteIcon />
                                </IconButton>
                              )}
                            </TableCell>
                          </TableRow>
                        ))}
                    </TableBody>
                  </Table>
                </TableContainer>
                <div className="flex items-center justify-end  ">
                  <TablePagination
                    sx={{
                      "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows":
                        {
                          outline: "none", // Remove the yellow focus outline
                          boxShadow: "none", // Remove any box shadow
                          margin: 0, // Remove default margin
                        },
                      "& .MuiSelect-select": {
                        "&:focus": {
                          outline: "none", // Remove focus from select dropdown
                          boxShadow: "none",
                        },
                      },
                    }}
                    rowsPerPageOptions={[10, 25, 50]}
                    component="div"
                    count={filteredData.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {showConfirmDialog && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-80">
          <div className="bg-white  rounded-md shadow-lg h-3/10 w-1/3 flex flex-col justify-between   ">
            <div className="flex font-poppins sm:text-xs md:text-[14px] bg-primary-title text-white p-6">
              <p>Are you sure you want to delete {selectedUser} ?</p>
            </div>
            <div className="mt-4 flex justify-center gap-x-6 pb-5 ">
              <button
                onClick={() => handleDelete(selectedUserID)}
                className="bg-primary-title text-white font-poppins md:text-[14px] py-2 rounded mr-2 px-8"
              >
                {isDeleting ? (
                  <svg
                    aria-hidden="true"
                    role="status"
                    className="inline w-7 h-7 me-3 text-white animate-spin "
                    viewBox="0 0 100 101"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                      fill="#E5E7EB"
                    />
                    <path
                      d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                      fill="currentColor"
                    />
                  </svg>
                ) : (
                  <span className="font-poppins">Yes</span>
                )}
              </button>
              <button
                onClick={handleCancelChange}
                className=" text-primary-title border-2 border-primary-title font-poppins md:text-[14px] py-2 rounded px-8"
              >
                NO
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Index;
